import React from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";
import { useLanguage } from '../../context/LanguageContext';

const HeaderS2 = (props) => {
    const { lang, setLang, t } = useLanguage();

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <header id="header">
            <div className={"" + props.hclass}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <MobileMenu />
                            </div>
                            <div className="col-lg-2 col-md-6 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/"><img src={props.Logo}
                                        alt="VitAnimal Kedi Köpek Sağlık Ürünleri Logosu" /></Link>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li><Link onClick={ClickHandler} to="/">{t('nav.home')}</Link></li>
                                        <li><Link onClick={ClickHandler} to="/about">{t('nav.about')}</Link></li>
                                        <li><Link onClick={ClickHandler} to="/shop">{t('nav.products')}</Link></li>
                                        <li><Link onClick={ClickHandler} to="/bilgi-formlari">{t('nav.forms')}</Link></li>
                                        <li><Link onClick={ClickHandler} to="/contact">{t('nav.contact')}</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-2 col-2">
                                <div className="header-right" style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'flex-end' }}>
                                    {/* Dil Değiştirici */}
                                    <div className="lang-switcher" style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                        <button
                                            onClick={() => setLang('tr')}
                                            title="Türkçe"
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                padding: 0,
                                                cursor: 'pointer',
                                                borderRadius: '50%',
                                                overflow: 'hidden',
                                                width: '32px',
                                                height: '32px',
                                                opacity: lang === 'tr' ? 1 : 0.45,
                                                transition: 'opacity 0.2s, box-shadow 0.2s',
                                                boxShadow: lang === 'tr' ? '0 0 0 2px #ff5b2e' : 'none',
                                                flexShrink: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <img
                                                src="https://flagcdn.com/w40/tr.png"
                                                alt="TR"
                                                style={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '50%', display: 'block' }}
                                            />
                                        </button>
                                        <button
                                            onClick={() => setLang('en')}
                                            title="English"
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                padding: 0,
                                                cursor: 'pointer',
                                                borderRadius: '50%',
                                                overflow: 'hidden',
                                                width: '32px',
                                                height: '32px',
                                                opacity: lang === 'en' ? 1 : 0.45,
                                                transition: 'opacity 0.2s, box-shadow 0.2s',
                                                boxShadow: lang === 'en' ? '0 0 0 2px #ff5b2e' : 'none',
                                                flexShrink: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <img
                                                src="https://flagcdn.com/w40/gb.png"
                                                alt="EN"
                                                style={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '50%', display: 'block' }}
                                            />
                                        </button>
                                    </div>
                                    <div className="close-form">
                                        <Link onClick={ClickHandler} className="theme-btn" to="/contact">{t('nav.contactBtn')}</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}
const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};

export default connect(mapStateToProps, { removeFromCart })(HeaderS2);
